module.exports = "<span>\n    <clr-icon shape=\"filter\" size=\"12\" class=\"is-solid filter-icon\"></clr-icon>\n    <input type=\"text\" style=\"padding-left: 15px;\" (keyup)=\"valueChange()\" placeholder=\"{{placeHolder}}\" [(ngModel)]=\"currentValue\"/>\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/filter/filter.component.html
// module id = 885
// module chunks = 0